export const SET_THEME = 'SET_THEME';

export const SET_SIGNED_IN = 'SET_SIGNED_IN';
export const SET_SIGNED_OUT = 'SET_SIGNED_OUT';
export const SET_RESET_PASSWORD_DONE = 'SET_RESET_PASSWORD_DONE';
export const SET_NEW_PASSWORD_DONE = 'SET_NEW_PASSWORD_DONE';
export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';

export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';

export const SET_FORM_STATUS = 'SET_FORM_STATUS';

// KPI
export const SET_START_DATE = 'SET_START_DATE';
export const SET_END_DATE = 'SET_END_DATE';
export const FETCH_KPI_DATA_REQUEST = 'FETCH_KPI_DATA_REQUEST';
export const FETCH_KPI_DATA_SUCCESS = 'FETCH_KPI_DATA_SUCCESS';
export const FETCH_KPI_DATA_FAILURE = 'FETCH_KPI_DATA_FAILURE';